import { render } from "./Booking_OptionalTour.vue?vue&type=template&id=44599ba1&scoped=true"
import script from "./Booking_OptionalTour.vue?vue&type=script&lang=js"
export * from "./Booking_OptionalTour.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-44599ba1"

export default script